@if (visible()) {
    @if (mode === "toolbar" && !viewportFitsAlert()) {
        <button
            mat-icon-button
            [color]="compactIconColor()"
            [matTooltip]="compactLabel()"
            [attr.aria-label]="compactLabel()"
            (click)="navigate()"
        >
            <mat-icon>{{ alertIcon() }}</mat-icon>
        </button>
    } @else {
        <fuse-alert
            class="h-12"
            [ngClass]="{ 'cursor-pointer': mode === 'toolbar' || showExhaustedUpsell() }"
            (click)="mode === 'toolbar' || showExhaustedUpsell() ? navigate() : null"
            [appearance]="'outline'"
            [type]="alertType()"
            [dismissible]="dismissible"
            [showIcon]="true"
            (dismissedChanged)="onDismissed()"
        >
            <mat-icon fuseAlertIcon>{{ alertIcon() }}</mat-icon>
            <span fuseAlertMessage>
                {{ message() }}
                @if (supportHint()) {
                    <span class="ml-1">{{ supportHint() }}</span>
                }
            </span>
        </fuse-alert>
    }
}
